import { render, staticRenderFns } from "./List-pumkm.vue?vue&type=template&id=5dea1648&scoped=true&"
import script from "./List-pumkm.vue?vue&type=script&lang=js&"
export * from "./List-pumkm.vue?vue&type=script&lang=js&"
import style0 from "./List-pumkm.vue?vue&type=style&index=0&id=5dea1648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea1648",
  null
  
)

export default component.exports